<!--BasePage:基础页 2022/09/30 11:06:37 YuAng-->
<script>
export default {
  name: 'BasePage',
  methods: {
    jumpNext: function () {
      window.open(process.env.VUE_APP_SS_URL + '/index#viewSum/index', '_blank')
    }
  }
}
</script>